import React from 'react';

import { useModalStore } from 'bdvp-common/src/hooks/store';
import { constants as modalConstants } from 'bdvp-graphql/src/resolvers/modals';

import useSelectedFiltersStore from '../hooks/store/useSelectedFiltersStore';
import useIsFilterInModal from '../hooks/useIsFilterInModal';
import TagsComponent from '../components/Tags';

const { FILTER_MODAL_NAME } = modalConstants;

const Tags = () => {

    const { isModalOpen } = useModalStore();
    const isFilterModalOpen = isModalOpen(FILTER_MODAL_NAME);
    const isFilterInModal = useIsFilterInModal();
    const { selectedFilters, removeSelectedFilter } = useSelectedFiltersStore();

    return (
        <TagsComponent
            selectedFilters={selectedFilters}
            removeFilter={removeSelectedFilter}
            shouldNotReRender={isFilterModalOpen && isFilterInModal}
        />
    );

};

export default Tags;
